//全局批量导入vant 组件
import {
    Button,
    List,
    Dialog,
    NavBar,
    PullRefresh,
    Image as VanImage,
    Icon,
    Form,
    Field,
    Toast,
    Locale,
    Checkbox,
    CheckboxGroup,
    RadioGroup,
    Radio,
    Popup,
    DatetimePicker,
    Tag,
    Popover,
    Row,
    Col,
    CountDown,
    Step,
    Steps,
    Stepper,
    IndexBar,
    IndexAnchor,
    Cell,
    Picker,
    Overlay,
    ActionSheet,
    Circle,
    Loading,
    ImagePreview,
    Uploader,
    Swipe,
    SwipeItem,
    Slider,
    Search,
    NumberKeyboard,
    Lazyload,
    Progress,
} from 'vant'

export default function (Vue) {
    //全局注册vant引用组件
    Vue.use(NumberKeyboard)
    Vue.use(Button)
    Vue.use(List)
    Vue.use(Dialog)
    Vue.use(NavBar)
    Vue.use(PullRefresh)
    Vue.use(VanImage)
    Vue.use(Icon)
    Vue.use(Form)
    Vue.use(Field)
    Vue.use(Toast)
    Vue.use(Locale)
    Vue.use(Checkbox)
    Vue.use(CheckboxGroup)
    Vue.use(Radio)
    Vue.use(RadioGroup)
    Vue.use(Popup)
    Vue.use(DatetimePicker)
    Vue.use(Popover)
    Vue.use(Tag)
    Vue.use(Step)
    Vue.use(Steps)
    Vue.use(Stepper)
    Vue.use(IndexBar)
    Vue.use(IndexAnchor)
    Vue.use(Cell)
    Vue.use(Col)
    Vue.use(Row)
    Vue.use(CountDown)
    Vue.use(Picker)
    Vue.use(Overlay)
    Vue.use(ActionSheet)
    Vue.use(Circle)
    Vue.use(Loading)
    Vue.use(Uploader)
    Vue.use(Swipe)
    Vue.use(SwipeItem)
    Vue.use(Slider)
    Vue.use(ImagePreview)
    Vue.use(Search)
    Vue.use(Lazyload, {
        lazyComponent: true,
    })
    Vue.use(Progress)
}
